





























import { Component, Vue } from 'vue-property-decorator';
import { AgencySettingsModule } from '@/store/modules/agencySettings';
import Uniforms from '@/components/Uniforms/Uniforms.vue'
import Alert from '@/components/Shared/Alert.vue'
import GiganautVue from '@/components/Shared/GiganautVue'
import PageNames from '@/router/PageNames';


@Component({
	name: 'AgencyUniformSettings',
  	components: { Uniforms, Alert }
})
export default class extends GiganautVue {

	beforeMount() {
		AgencySettingsModule.getUniforms();
  	}

	navigateToAgencySettings() {
		this.$router.push({ name: PageNames.AgencySettings });
	}

  	get loading() {
		return AgencySettingsModule.loadingUniforms;
  	}
}
